var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Model } from '@veeam/core';
import { parseTextInputValue, parseTextToNumber, getCountSimbolsAfterComma } from './helpers';
export var NUMBER_INPUT_VALIDATION_ERROR;
(function (NUMBER_INPUT_VALIDATION_ERROR) {
    NUMBER_INPUT_VALIDATION_ERROR["minValueLimit"] = "minValueLimit";
    NUMBER_INPUT_VALIDATION_ERROR["maxValueLimit"] = "maxValueLimit";
})(NUMBER_INPUT_VALIDATION_ERROR || (NUMBER_INPUT_VALIDATION_ERROR = {}));
var DEFAULT_CONFIG = {
    allowDecimal: false,
    precision: 2
};
var NumberInputInteractor = /** @class */ (function () {
    function NumberInputInteractor(initValue, internalConfig, listener) {
        var _this = this;
        this.internalConfig = internalConfig;
        this.listener = listener;
        this.changeByText = function (textValue) {
            var _a, _b;
            var config = _this.getConfig();
            var _c = parseTextInputValue(textValue, {
                disallowDecimal: !config.allowDecimal
            }), value = _c.value, isDraft = _c.isDraft, isInvalid = _c.isInvalid;
            var countSimbolsAfterComma = getCountSimbolsAfterComma(textValue);
            if (config.allowDecimal && config.precision && countSimbolsAfterComma > config.precision) {
                return;
            }
            if (isInvalid) {
                return;
            }
            if (isDraft) {
                (_b = (_a = _this.listener) === null || _a === void 0 ? void 0 : _a.onDraftValueChange) === null || _b === void 0 ? void 0 : _b.call(_a, value);
                return;
            }
            if ((value || 0) > Number.MAX_SAFE_INTEGER || (value || 0) < Number.MIN_SAFE_INTEGER) {
                return;
            }
            _this.change(parseTextToNumber(value));
        };
        this.change = function (value) {
            var _a, _b, _c, _d;
            (_b = (_a = _this.listener) === null || _a === void 0 ? void 0 : _a.onDraftValueChange) === null || _b === void 0 ? void 0 : _b.call(_a, '');
            _this.setValue(value);
            (_d = (_c = _this.listener) === null || _c === void 0 ? void 0 : _c.onChange) === null || _d === void 0 ? void 0 : _d.call(_c, value);
        };
        this.add = function (value) {
            var config = _this.getConfig();
            var startValue = _this.model.getValue().value || 0;
            var notRoundedNextValue = (_this.model.getValue().value || 0) + value;
            var newValue = config.precision
                ? Number.parseFloat(notRoundedNextValue.toFixed(config.precision))
                : notRoundedNextValue;
            if (typeof config.maxLimit === 'number' &&
                newValue > config.maxLimit &&
                newValue > startValue) {
                return;
            }
            if (typeof config.minLimit === 'number' &&
                newValue < config.minLimit &&
                newValue < startValue) {
                return;
            }
            _this.change(newValue);
        };
        this.getValue = function () {
            return _this.model.getValue().value;
        };
        this.setConfig = function (config) {
            _this.internalConfig = config;
            _this.change(_this.model.getValue().value);
        };
        this.getConfig = function () {
            return __assign(__assign({}, DEFAULT_CONFIG), _this.internalConfig);
        };
        this.model = new Model({ value: initValue });
        this.setValue(initValue);
    }
    NumberInputInteractor.prototype.validate = function () {
        var _a, _b;
        var error;
        var value = this.model.getValue().value;
        var config = this.getConfig();
        if (typeof value === 'number' &&
            typeof config.maxLimit === 'number' &&
            value > config.maxLimit) {
            error = NUMBER_INPUT_VALIDATION_ERROR.maxValueLimit;
        }
        if (typeof value === 'number' &&
            typeof config.minLimit === 'number' &&
            value < config.minLimit) {
            error = NUMBER_INPUT_VALIDATION_ERROR.minValueLimit;
        }
        if (error) {
            (_b = (_a = this.listener) === null || _a === void 0 ? void 0 : _a.onValidationError) === null || _b === void 0 ? void 0 : _b.call(_a, error);
        }
    };
    NumberInputInteractor.prototype.setValue = function (value) {
        this.model.setValue({ value: value });
        this.validate();
    };
    return NumberInputInteractor;
}());
export { NumberInputInteractor };
//# sourceMappingURL=Interactor.js.map